import ISpineAnimConfig from "../managers/contracts/configurations/spine_anim/ISpineAnimConfig";
import ISpineAnimStateConfig from "../managers/contracts/configurations/spine_anim/ISpineAnimStateConfig";
import IChainingSpineAnimConfig from "../managers/contracts/configurations/spine_anim/IChainingSpineAnimConfig";
import {ConfigurationTypes} from "../const/ConfigurationTypes";
import ISceneSpineAnimConfig from '../managers/contracts/configurations/ISceneSpineAnimConfig';
import ConsoleUtil from "../utils/ConsoleUtil";
export default abstract class AbstractSceneSpineAnimationsConfig implements ISceneSpineAnimConfig {
    type: ConfigurationTypes = ConfigurationTypes.SPINE_ANIMATIONS;

    anims: ISpineAnimConfig[];

    getStateConfig(state: string, anim: string): ISpineAnimStateConfig {
        let result = null;
        let animConfig =  this.getAnimConfig(anim);
        if (animConfig) {
            result = animConfig.states.find(data => data.name === state)
        }

        return result
    }
    getChainingAnimConfig(chainingAnim: string, anim: string): IChainingSpineAnimConfig {
        let result = null;
        let animConfig =  this.getAnimConfig(anim);
        if (animConfig) {
            result = animConfig.chainingStates.find(data => data.name === chainingAnim)
        }

        return result
    }
    getAnimConfig(animName: string): ISpineAnimConfig {
        let result = null;
        for (let i = 0; i < this.anims.length; i++) {
            const anim = this.anims[i];
            if (anim.name === animName) {
                result = anim; break;
            }
        }

        if (result === null) {
            ConsoleUtil.warn(
                `[SPINE ANIMATION] -> animation <${animName}> Has not a configuration in SpineAnimationConfig`,
                this.anims
            );
        }

        return result
    }
}
